module.exports = __webpack_public_path__ + "img/float.9e1326e4.jpg";